import { IncidentModel } from './incident.model';

export class IncidentLawEnforcementOOJModel extends IncidentModel {

    private _convictionDate: Date;

    public incidentLawEnforcementId = 0;
    public citingAgencyTypeId = 0;
    public accidentTypeId = 0;
    public jurisdictionId = 0;
    public jurisdictionDescription: string;
    public bac = 0.0;
    public stateNativeCode: string;
    public orderOfSuspensionServedByOfficerDate: any;
    public isOperatingCommercialMotorVehicle = false;
    public cdlHolderIndicator = false;
    public isDrugsInvolved = false;
    public isHazmat = false;
    public driverLicenseJurisdictionId: number;
    public driverLicenseNumber: string;
    public get convictionDate(): Date {
        return this._convictionDate;
    }
    public set convictionDate(value: Date) {
        this._convictionDate = this.ensureDate(value);
    }
    public complaintNumber: string;
}
